import React, { useEffect, useMemo } from "react";
import { AppBar, Toolbar, IconButton, InputAdornment, InputBase, } from "@mui/material";
import { useAppSettings } from "../../contexts/app-context/AppContext";
import { useForm } from "react-hook-form";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SearchIcon from "@mui/icons-material/Search";
import { UIViewEnum } from "../../common/enums/UIViewEnum";
import { useRouteContext } from "../../hooks/use-route-context/UseRouteContext";
import { getGroupRoute } from "../../common/utilities/RouteHelpers";
import { asInputRef } from "../../common/utilities/AsInputRef";
import { createTheme, Theme, ThemeProvider } from '@mui/material/styles';
import { NavigationSource } from "../../common/enums/NavigationSource";
import { SxProps } from "@mui/system";
import useNavigateTo from "../../hooks/use-navigate-to/useNavigateTo";

export type MobileSearchBarProps = {
    onClose: () => void;
    position?: 'fixed' | 'absolute';
    sx?: SxProps<Theme>;
};

type SearchFormProp = {
    search: string
};

export default function MobileSearchBar({ onClose, position, sx }: MobileSearchBarProps) {

    const [appSettings] = useAppSettings();
    const {
        getValues,
        handleSubmit,
        register,
        resetField
    } = useForm();
    const navigateTo = useNavigateTo();
    const routeContext = useRouteContext();


    const theme = useMemo(
        () => {
            return createTheme(appSettings.themeSet[appSettings.themeSet.mode].appHeaderV1);
        },
        [appSettings.themeSet]
    );

    useEffect(() => {

        if (routeContext.navSrc === NavigationSource.SearchResults) {

            const searchValue: string | undefined = getValues("search");

            if ((searchValue?.length ?? 0) > 0) {

                resetField("search");
            }
        }
    },
        [
            getValues,
            resetField,
            routeContext.navSrc
        ]);

    const handleSearch = (data: any) => {

        //alert(`Search for ${JSON.stringify(data)}`);

        const searchData = data as SearchFormProp;


        if (searchData.search) {

            const text = searchData.search.trim();
            if (text.length > 0) {

                const url = `${getGroupRoute(UIViewEnum.SearchResults, routeContext.groupID as number)}&token=${text}`;
                navigateTo(url)
            }
        }
    };

    return (


        <AppBar position={position ? position : 'absolute'}
            sx={{
                zIndex: theme.zIndex.drawer + 1,
                transition: theme.transitions.create(["width", "margin"], {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
                ...sx
            }} >
            <Toolbar>

                {/* Toggle Drawer Button */}
                <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="open drawer"
                    onClick={() => onClose()}>
                    <ArrowBackIcon />
                </IconButton>

                {/* Make TextField think it's being used with a dark theme */}
                <ThemeProvider theme={theme}>
                    {/* Mobile Search Input */}
                    <form onSubmit={handleSubmit(handleSearch)}
                        style={{ width: "100%" }}
                    //className={classes.mobileSearchInput}
                    >
                        <InputBase
                            fullWidth
                            autoFocus
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        color="inherit"
                                        type="submit"
                                        aria-label="Search entire site">
                                        <SearchIcon />
                                    </IconButton>
                                </InputAdornment>}
                            {...asInputRef(register("search"))}
                        />
                    </form>
                </ThemeProvider>
            </Toolbar>
        </AppBar>

    );
}
